<template>
    <div>
        <div class="certificate">
            <div class="examine">
                <p>待他人操作</p>
                <span @click="viewAll">查看全部</span>
            </div>
            <avue-crud :data="data" :option="option" ></avue-crud>
        </div>
    </div>
</template>

<script>
    export default {
        name: "othersOperation",
        data(){
            return {
                data: [
                    {
                        title:'张三',
                        sender:'男',
                        signed:'地王大厦',
                        state:'已完成',
                        time:'2022.10.10'
                    }, {
                        title:'李四',
                        sender:'女',
                        signed:'规范化',
                        state:'已完成',
                        time:'2022.10.11'
                    },
                    {
                        title:'李四',
                        sender:'女',
                        signed:'规范化',
                        state:'已完成',
                        time:'2022.10.11'
                    }
                ],
                option:{
                    border:false,
                    align:'center',
                    menuAlign:'center',
                    editBtn:false,
                    delBtn:false,
                    viewBtn:true,
                    refreshBtn: false, //刷新按钮
                    columnBtn: false, //表格右侧操作列显隐的按钮
                    addBtn:false, //左上角新增
                    column:[
                        {
                            label:'合同标题',
                            prop:'title'
                        }, {
                            label:'发件人',
                            prop:'sender'
                        },{
                            label:'签署人',
                            prop:'signed'
                        },{
                            label:'合同状态',
                            prop:'state'
                        },{
                            label:'发起时间',
                            prop:'time'
                        }
                    ]
                },
            };
        },
        methods:{
            viewAll(){
                console.log(111)
            }
        }
    }
</script>

<style scoped>
    .certificate{
        /*margin-top: 30px;*/
        padding: 5px 20px;
    }
    .examine{
        display: flex;
        justify-content: space-between
    }
    .examine>P{
        font-weight: 700;
    }
    .examine>span{
        cursor:pointer;
        color: #2a4ac0;
    }
    /deep/ .avue-crud__menu{
        min-height: 0px;
    }
</style>
